import {useCallback, useState} from 'react';
import {Button} from '@mui/material';
import QRCodeStyling from 'qr-code-styling';
import {useMutation} from '@tanstack/react-query';
import speakerLogo from '../../../../../../src/asset/images/speaker-logo.jpg';
import {StoreMediaDeviceQrCodeToken} from '../../../../../react_query/media_devices/StoreMediaDeviceToken';

const QRCodeLoginButton = ({
  company_id,
  station_id,
}: {
  company_id: number;
  station_id: number;
}) => {
  const [loading, setLoading] = useState(false);

  const store = useMutation({
    mutationFn: () => {
      return StoreMediaDeviceQrCodeToken(company_id, station_id);
    },
    onSuccess(response) {
      const qrCode = new QRCodeStyling({
        width: 150,
        height: 150,
        data: response.token,
        image: speakerLogo,
        imageOptions: {crossOrigin: 'anonymous'},
      });
      qrCode.download({name: 'Login QR', extension: 'jpeg'});
    },
    onSettled() {
      setLoading(false);
    },
  });

  const handleClick = useCallback(() => {
    setLoading(true);
    store.mutate();
  }, [store]);

  return (
    <Button variant='contained' disabled={loading} onClick={handleClick}>
      Player login QR
    </Button>
  );
};

export default QRCodeLoginButton;
